import publicApiClient from '../clients/publicApiClient';
import { API_ENDPOINTS } from '../endpoints';

export const permissionsApi = {
  getCsrfMap() {
    return publicApiClient.get(API_ENDPOINTS.permissions.csrfMap);
  },
};
